import { Hub } from "aws-amplify/utils";
import { history } from "../stores";
import ReactGA from "react-ga";

enum AuthEvents {
  COGNITO_HOSTEDUI_FAILURE = "cognitoHostedUI_failure",
  SIGNUP = "signUp",
  SIGNIN = "signIn",
}

export default function initAuthHub() {
  const listener = (data: { payload: { event: string; data?: any } }) => {
    const { event } = data.payload;
    try {
      switch (event) {
        case AuthEvents.COGNITO_HOSTEDUI_FAILURE:
          history.replace("/?google_error=authentication_error");
          break;
        case AuthEvents.SIGNIN:
          const sub = data.payload.data?.username;
          if (sub) {
            ReactGA.set({ sub });
          }
          break;
        case AuthEvents.SIGNUP:
          const signUpData = data.payload.data;
          if (signUpData) {
            ReactGA.set({ email: signUpData.username, sub: signUpData.userSub });
          }
          break;
        default:
          break;
      }
    } catch (error) {
      console.log(error);
    }
  };

  Hub.listen("auth", listener);
}
